module.exports = __webpack_public_path__ + "static/sport/register-success-new.a73ab13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport5/register-success-new.png
// module id = Iuqj
// module chunks = 0